// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

const PREVIEW_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PREVIEW_ROUTE}`;

import AuthApi from '@/store/api/system/auth';
import PointsOfSaleGql from '@/extensions/shop/pointOfSale/store/graphql/queries/PointsOfSale.gql';

import { parseInt } from 'lodash';

export default {
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: PointsOfSaleGql,
                    variables,
                })
                .then(({ data }) => resolve(data.EX_POS_PointsOfSale))
                .catch((err) => reject(err));
        }),

    setActivePointOfSaleId(id) {
        return localStorage.setItem('active-pos-id', id);
    },
    getActivePointOfSaleId() {
        return localStorage.getItem('active-pos-id') || null;
    },
    getActiveStockId() {
        return localStorage.getItem('active-stock-id') || null;
    },
    removeActivePointOfSaleId() {
        localStorage.removeItem('active-pos-id');
    },

    pendingReservationPurchasesRenderingUrl(id, action = 'preview') {
        const token = AuthApi.getToken();
        return `${PREVIEW_ENDPOINT}pending-reservation-purchases/${id}?${action}&token=${token}`;
    },
};
